import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import {
    getShopifyPayoutsApi,
    getShopifyPayoutDetailsApi,
    exportShopifyPayoutDetailApi,
    getShopifyPayoutXeroInvoicesApi,
    generatePaymentsApi,
    sendToXeroApi,
    getPaymentSourceDetailsApi,
    exportPaymentSourceDetailsApi,
    getPayoutMatchCheckApi,
    recheckPayoutLinesApi,
} from "../../../../services/payout";


export const getShopifyPayouts = createAsyncThunk('report/getShopifyPayouts', async (data, { dispatch }) => {
    const response = await getShopifyPayoutsApi(data);
    dispatch(setShopifyPayoutsData(response.response));
    return response.response;
});

export const getShopifyPayoutDetail = createAsyncThunk('report/getShopifyPayoutDetail', async (data, { dispatch }) => {
    const response = await getShopifyPayoutDetailsApi(data);
    dispatch(setShopifyPayoutDetailsData(response.response));
    return response.response;
});

export const exportShopifyPayoutDetail = createAsyncThunk('report/exportShopifyPayoutDetail', async (data, { dispatch }) => {
    const response = await exportShopifyPayoutDetailApi(data);
    return response.response;
});

export const getShopifyPayoutXeroInvoices = createAsyncThunk('report/getShopifyPayoutXeroInvoices', async (data, { dispatch }) => {
    const response = await getShopifyPayoutXeroInvoicesApi(data);
    dispatch(setShopifyPayoutXeroInvoicesData(response.response));
    return response.response;
});

export const generatePayments = createAsyncThunk('report/generatePayments', async (data, { rejectWithValue }) => {
    try {
        const response = await generatePaymentsApi(data);
        return response.response;
    } catch (err) {
        return rejectWithValue(typeof err === 'object' ? err : { error: String(err) });
    }
});

export const getPayoutMatchCheck = createAsyncThunk('report/getPayoutMatchCheck', async (id, { dispatch }) => {
    const response = await getPayoutMatchCheckApi(id);
    dispatch(setPayoutMatchCheckData(response.response));
    return response.response;
});

export const sendToXero = createAsyncThunk('report/sendToXero', async (data, { dispatch }) => {
    const response = await sendToXeroApi(data);
    return response.response;
});

export const getPaymentSourceDetail = createAsyncThunk('report/getPaymentSourceDetail', async (data, { dispatch }) => {
    const response = await getPaymentSourceDetailsApi(data);
    dispatch(setPaymentSourceDetailData(response.response));
    return response.response;
});

export const exportPaymentSourceDetail = createAsyncThunk('report/exportPaymentSourceDetail', async (data) => {
    const response = await exportPaymentSourceDetailsApi(data);
    return response.response;
});

export const recheckPayoutLines = createAsyncThunk('report/recheckPayoutLines', async (payoutId, { rejectWithValue }) => {
    try {
        const response = await recheckPayoutLinesApi(payoutId);
        return response.response;
    } catch (err) {
        return rejectWithValue(typeof err === 'object' ? err : { error: String(err) });
    }
});


const payoutReportAdapter = createEntityAdapter({});

export const { selectAll: selectPayoutReport, selectById: selectPayoutReportById } = payoutReportAdapter.getSelectors(
    state => state.report
);

const payoutReportSlice = createSlice({
    name: 'payoutReport',
    initialState: payoutReportAdapter.getInitialState({
        id: null,
        settings: {
            partners: [],
            deliveryPartners: [],
            shippingTypes: [],
            currencies: [],
        },
        filters: {
            startDate: null,
            endDate: null,
            partner: null
        },
        shopifyPayoutLists: [],
        shopifyPayoutTableRow: 0,
        shopifyPayoutTotalSummary: null,
        shopifyPayoutDetailLists: [],
        shopifyPayoutDetailTableRow: 0,
        shopifyPayoutDetail: null,
        shopifyPayoutDetailTotalSummary: null,
        shopifyPayoutXeroInvoiceLists: [],
        shopifyPayoutXeroInvoiceTableRow: 0,
        paymentSourceDetailLists: [],
        paymentSourceDetailTableRow: 0,
        paymentSourceDetailHeader: null,
        paymentSourceDetailTotalSummary: null,
        paymentSourceDetailMatchSummary: null,
        payoutMatchCheckSummary: null,
        payoutMatchCheckLines: [],
    }),
    reducers: {
        setSettings: (state, action) => {
            state.settings.partners = action.payload.partners;
            state.settings.deliveryPartners = action.payload.delivery_partners;
            state.settings.shippingTypes = action.payload.shipping_types;
            state.settings.currencies = action.payload.currencies;
        },
        setFilter: (state, action) => {
            state.filters = action.payload;
        },
        setShopifyPayoutsData: (state, action) => {
            state.shopifyPayoutLists = action.payload.data;
            state.shopifyPayoutTableRow = action.payload.total;
            // state.shopifyPayoutTotalSummary = action.payload.total_summary;
        },
        setShopifyPayoutDetailsData: (state, action) => {
            state.shopifyPayoutDetailLists = action.payload.details.data;
            state.shopifyPayoutDetailTableRow = action.payload.details.total;
            state.shopifyPayoutDetail = action.payload.payout;
            state.shopifyPayoutDetailTotalSummary = action.payload.details.total_summary;
        },
        setShopifyPayoutXeroInvoicesData: (state, action) => {
            state.shopifyPayoutXeroInvoiceLists = action.payload.data;
            state.shopifyPayoutXeroInvoiceTableRow = action.payload.total;
        },
        setPaymentSourceDetailData: (state, action) => {
            state.paymentSourceDetailLists = action.payload.data;
            state.paymentSourceDetailTableRow = action.payload.total;
            state.paymentSourceDetailHeader = action.payload.header;
            state.paymentSourceDetailTotalSummary = action.payload.total_summary;
            state.paymentSourceDetailMatchSummary = action.payload.match_summary ?? null;
        },
        setPayoutMatchCheckData: (state, action) => {
            state.payoutMatchCheckSummary = action.payload.summary;
            state.payoutMatchCheckLines   = action.payload.lines ?? [];
        },
    },
    extraReducers: {
        // [getPayoutReport.fulfilled]: payoutReportAdapter.setAll
    }
});

export const {
    setSettings,
    setFilter,
    setShopifyPayoutsData,
    setShopifyPayoutDetailsData,
    setShopifyPayoutXeroInvoicesData,
    setPaymentSourceDetailData,
    setPayoutMatchCheckData,
} = payoutReportSlice.actions;

export default payoutReportSlice.reducer;